<template>
  <div class="health_">
    <div class="head_">
      <cube-input
        v-model="value"
        class="search_"
        @keyup.enter.native="getHipSalMedicalTest"
        placeholder="请输入客户姓名或口令号查询"
      >
      </cube-input>
      <img
        class="del_"
        @click="
          () => {
            value = '';
          }
        "
        v-if="value != ''"
        src="../../../assets/image/nsale/pcenter/del.png"
        alt=""
      />
      <div class="btn_" @click="getHipSalMedicalTest">查询</div>
      <img
        @click="getHipSalMedicalTest"
        class="img_"
        src="../../../assets/image/nsale/search.png"
        alt=""
      />
    </div>

    <div class="list_" v-for="(item, index) in list" :key="index">
      <div class="flex_ tit_">
        {{ item.productName || "-" }}
        <span :class="[item.isAppointment == 'N' ? 'gray_' : '']">{{
          item.isAppointment | filterAppoint
        }}</span>
      </div>
      <p>订单口令号：{{ item.medicalTestWord }}</p>
      <p>
        购买日期：{{
          item.creatDate ? moment(item.creatDate).format("YYYY-MM-DD") : ""
        }}
      </p>
      <p>支付状态：{{ item.payStatus | filterPay }}</p>
      <p>客户姓名：{{ item.name }}</p>
      <div class="flex_">
        手机号码：{{ item.phone }}
        <span>订单金额</span>
      </div>
      <div class="flex_">
        预约日期：{{
          item.appointmentDate
            ? moment(item.appointmentDate).format("YYYY-MM-DD")
            : ""
        }}
        <span class="bold_">{{ item.productPrice.toFixed(2) }}</span>
      </div>
    </div>

    <div class="null_">没有更多数据了</div>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";

export default {
  data() {
    return {
      value: "",
      list: []
    };
  },
  filters: {
    filterPay(val) {
      if (val == "1") {
        return "未支付";
      } else if (val == "2") {
        return "已支付";
      }
    },
    filterAppoint(val) {
      if (val == "Y") {
        return "已预约";
      } else if (val == "N") {
        return "未预约";
      }
    }
  },
  mounted() {
    this.getHipSalMedicalTest();
  },
  methods: {
    moment,
    getHipSalMedicalTest() {
      let data = {
        param: this.value
      };
      let params = {
        userId: this.$route.query.userId
      };
      api.getHipSalMedicalTest(params, data).then(res => {
        this.list = res.data.content;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.health_ {
  font-family: PingFangSC-Medium, PingFang SC;
  width: 100%;
  min-height: 100vh;
  background: rgba(248, 248, 248, 1);
  padding: 0.4rem 0.53rem;
  .head_ {
    position: relative;
    .del_ {
      width: 11px;
      height: auto;
      position: absolute;
      right: 1.6rem;
      top: 12px;
    }
    .btn_ {
      font-size: 0.27rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      position: absolute;
      line-height: 0.75rem;
      right: 4px;
      top: 3px;
      width: 1.32rem;
      height: 0.75rem;
      background: linear-gradient(
        45deg,
        rgba(255, 124, 108, 1) 0%,
        rgba(255, 162, 151, 1) 100%
      );
      border-radius: 0.19rem;
    }
    .search_ {
      width: 8.93rem;
      height: 0.93rem;
      background: #fff;
      border-radius: 0.19rem;
      margin: 0 auto;
    }
    .img_ {
      position: absolute;
      width: 0.3rem;
      height: 0.3rem;
      background-size: contain;
      margin-left: 0.266667rem;
      top: 12px;
      left: 0;
    }
  }

  .list_ {
    margin-top: 0.33rem;
    padding: 0.39rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.19rem;
    .flex_ {
      display: flex;
      justify-content: space-between;
    }

    p,
    .flex_ {
      margin: 8px 0;
      text-align: left;
      font-size: 0.32rem;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
    }
    .tit_ {
      font-size: 0.4rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      span {
        color: rgba(255, 74, 53, 1);
      }
      margin-bottom: 16px;
    }
    .bold_ {
      font-size: 0.48rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }
  .null_ {
    margin: 0.52rem auto;
    font-size: 0.29rem;
    color: rgba(153, 153, 153, 1);
  }
  .gray_ {
    color: rgba(153, 153, 153, 1) !important;
  }
}
</style>
